function asFiniteNumber(n: number | null | undefined, fallback = 0): number {
  return typeof n === 'number' && Number.isFinite(n) ? n : fallback;
}

export function fmt(n: number | null | undefined) {
  return asFiniteNumber(n).toLocaleString('en-US');
}

export function fmtCost(usd: number | null | undefined) {
  const u = asFiniteNumber(usd);
  if (u === 0) return '$0.000000';
  if (u < 0.01) return `$${u.toFixed(6)}`;
  return `$${u.toFixed(4)}`;
}

export function fmtDate(iso: string) {
  try {
    return new Date(iso).toLocaleString('th-TH', {
      dateStyle: 'medium',
      timeStyle: 'medium',
    });
  } catch {
    return iso;
  }
}

export function shortId(id: string, n = 8) {
  if (!id || id.length <= n + 4) return id;
  return `${id.slice(0, n)}…`;
}
